import React from 'react'
import { Link } from 'react-router-dom'

import neatOpen from '../../assets/neatWrapSpinner320.gif'

import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { seoPageTags } from '../../helpers/analytics'

// Unavailable Page
const Unavailable = () => {
  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        '404'
      )}

      {/* Body */}
      <Box sx={{ height: '70vh', width: '100vw', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        {/* Neat wrapping present GIF */}
        <Box component='img' src={neatOpen} alt='neat open gif' sx={{ width: 150 }} />

        {/* 404 Not Found text */}
        <Typography variant='h4'>Sorry, 3D Wrap is Unavailable in your country.</Typography>

        {/* Link back to home.js */}
        <Typography as={Link} to="/" sx={{ textDecoration: 'underline' }}>Back to Home</Typography>
      </Box>
    </>
  )
}

export default Unavailable